import React from 'react';

const InvestigationalUseDialog = () => {
  return null; // Always hidden, never renders anything
};

export default InvestigationalUseDialog;
